module.exports = __webpack_public_path__ + "img/aguilas.442dc4f6.png";